module.exports = main;


//////////////////
// WEBPACK FOOTER
// external "main"
// module id = vB+P
// module chunks = 73